export function createConsentManager(el, userManager) {
  return {
    showConsentScreen() {
      const consentOverlay = el.querySelector('#chatyx-consent');
      const checkbox = el.querySelector('#chatyx-consent-checkbox');
      const acceptButton = el.querySelector('#chatyx-consent-accept');
      consentOverlay.classList.add('show');
      acceptButton.disabled = !checkbox.checked;
    },
    hideConsentScreen() {
      el.querySelector('#chatyx-consent').classList.remove('show');
    },
    checkAndShowConsent() {
      if (!userManager.getConsent()) {
        this.showConsentScreen();
        return false;
      }
      return true;
    }
  };
}
